// The chip on an item still needed that holds its step up, its reason on hover or focus
// rather than a line under the row (Noaa, 20 Oct 2026).
import type { AmazonNeed } from "../../api/hooks/useAmazonOverview";
import { Tooltip } from "../../components/Tooltip";
import { whyText } from "./needs";
import styles from "./amazonOverview.module.css";

export const HoldTag = ({ need, label }: { need: AmazonNeed; label: string }) => {
  const why = whyText(need);
  if (!why) return <span className={styles.holdTag}>{label}</span>;
  return (
    <Tooltip content={`Why: ${why}.`}>
      <span className={styles.holdTag} tabIndex={0}>
        {label}
      </span>
    </Tooltip>
  );
};
